import { observable } from "@legendapp/state"

interface FeaturebaseData {
  isIdentified: boolean
  isWidgetOpen: boolean
  unreadCount: number
}

const initialState: FeaturebaseData = {
  isIdentified: false,
  isWidgetOpen: false,
  unreadCount: 0,
}

export const featurebaseStore$ = observable(initialState)
